import React from 'react';
import styles from './Input.module.scss';
import ValidationErrorLabel from '../../ValidationErrorLabel/ValidationErrorLabel';

export function Input({
  isClosedVariant,
  type,
  placeholder,
  label,
  defaultValue,
  onChange,
  readOnly,
  value,
  onBlur,
  classes,
  error = false
}) {
  return (
    <div className={`${classes} ${isClosedVariant ? styles.InputClosedStyle : styles.InputComponent}`}>
      <label className={styles.label}>{label}</label>
      <input
        onBlur={onBlur}
        value={value}
        readOnly={readOnly}
        onChange={onChange}
        defaultValue={defaultValue}
        className={styles.InputStyles}
        type={type}
        placeholder={placeholder}
      />
      {error && <ValidationErrorLabel message={error} />}
    </div>
  );
}
